import {useEffect, useMemo, useState} from "react";
import liveBadge from "../../assets/images/live-bg/live.gif";
import {getDateF, getTime24H} from "../../utility/dateUtils";
import {generateTextOutline} from "../../constant/generateTextOutline";

// Replace this default message, or pass marqueeText to LiveBackground.
export const DEFAULT_MARQUEE_TEXT =
    "ក្រុមហ៊ុន P99 ពិភពឆ្នោត ៖ 👉 មានផ្សាយជូនទស្សនាលទ្ធផល ឆ្នោតខ្មែរ (KH-ខ្មែរ, MSHB-មហាសម្បត្តិ, SC-សប្បាយឈ្នះ) និង ឆ្នោតយួន (MT-មិញងុក 4-6, KP-កំពតមិញងុក, TC-ធិញណាំ) គ្រប់ប្រភេទ គ្រប់វេន និងជារៀងរាល់ថ្ងៃ។ 🔔 បើពុកម៉ែ បងប្អូន មានបំណងចង់ផ្សងសំណាង សូមចុចលីងភ្នាក់ងារកត់ឆ្នោតក្នុង ខមិន សូមអរគុណ 🙏 ចំណាំ >>> លើសន្លឹកឆ្នោតមានរូបឡូហ្គោ P99 ជាសម្គាល់ និង សូមទូទាត់ប្រាក់អោយបានមុនម៉ោងឆ្នោតចេញ ៕";

export default function LiveOverlay({
                                        marqueeText = DEFAULT_MARQUEE_TEXT,
                                        textStyle = {
                                            color: "#ffffff",
                                            outlineColor: "#09246f",
                                        },
                                    }) {
    const [now, setNow] = useState(() => Date.now());
    const color = textStyle?.color ?? "#ffffff";
    const outlineColor = textStyle?.outlineColor ?? "#09246f";

    const textOutline = useMemo(
        () => generateTextOutline(6, 64, outlineColor),
        [outlineColor]
    );

    const clockStyle = {
        color,
        textShadow: textOutline,
    };

    useEffect(() => {
        const timer = setInterval(() => {
            setNow(Date.now());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <>
      <span className="live-background__badge">
        <img src={liveBadge} alt="Live"/>
      </span>

            <time
                className="live-background__date"
                aria-label="Current date"
                style={clockStyle}
            >
                {getDateF(now)}
            </time>

            <time
                className="live-background__clock"
                aria-label="Current time"
                style={clockStyle}
            >
                {getTime24H(now)}
            </time>

            {marqueeText && (
                <div
                    className="live-background__marquee"
                    aria-label={marqueeText}
                >
                    <div
                        className="live-background__marquee-track"
                        aria-hidden="true"
                    >
                        <span>{marqueeText}</span>
                        <span>{marqueeText}</span>
                    </div>
                </div>
            )}
        </>
    );
}
